module.exports = __webpack_public_path__ + "img/file_edit.76c388ac.svg";